import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";
import { debounce } from '../utils/_debounce';
import anime from 'animejs';

/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Navigation extends Module {

	ready() {
		new ResponsiveNavigation('main_nav', 'navigation-toggle');
	}
}

class ResponsiveNavigation {

	constructor(ID, TOGGLE_ID) {
		
		this.ID = ID;
		this.TOGGLE_ID = TOGGLE_ID;
		this.BREAKPOINT = 1160;
		this.canToggle = true;

		this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

		// Elements
		this.NAV = document.getElementById(ID);
		this.MAIN_HEADER = document.getElementById('main_header');
		this.LOGO = document.querySelector('#main_header .logo');
		this.NAV_OVERLAY = document.getElementById('nav-overlay');
		this.NAV_TOGGLE = document.getElementById(TOGGLE_ID);
		this.ACTIVE_MENU_ITEM = document.querySelector('#menu-main-menu .current_page_item');
		
		// Display submenu for active menu item
		this.displaySubMenu();

		// Click on submenu
		this.submenuOnClick();

		// Toggle navigation on nav toggle click
		this.NAV_TOGGLE.addEventListener('click', this.toggleNavigation.bind(this));

		// Append dropdowns and wrap submenus
		this.appendDropdownArrows();
		//this.wrapSubmenu();

        // Testing
        //this.toggleNavigation();
		
		// Close navigation if window is resized
		this.RESIZE_NAV = debounce(() => {

			this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

			if (hasClass(document.body, 'nav-open')) {
				this.closeNavigation();
			}
		}, 300);

		window.addEventListener('resize', this.RESIZE_NAV);

	}

	toggleNavigation() {

		// Check if toggleable 
		this.toggleable();

		// Toggle elements
		toggleClass(this.NAV_TOGGLE, 'open');
		toggleClass(this.NAV, 'open');
		toggleClass(this.NAV_OVERLAY, 'show');
		toggleClass(document.body, 'nav-open');
	}

	// Check if menu is toggleable
	toggleable() {
		if (!this.canToggle) return;
		this.canToggle = false;
		setTimeout(() => { this.canToggle = true; }, 200);
	}

	// Close the navigation
	closeNavigation() {
		removeClass(this.NAV_TOGGLE, 'open');
		removeClass(this.NAV, 'open');
		removeClass(this.NAV_OVERLAY, 'show');
		removeClass(document.body, 'nav-open');
	}

	// Append dropdown arrows for items with children
	appendDropdownArrows() {

		const MENUS_WITH_CHILDREN = document.querySelectorAll('.menu-item-has-children');

		for (let i = 0; i < MENUS_WITH_CHILDREN.length; i++) {

			const MENU_ITEM = MENUS_WITH_CHILDREN[i];
			const DROPDOWN_ELEMENT = document.createElement('div');

			DROPDOWN_ELEMENT.className = 'dropdown-arrow';
			DROPDOWN_ELEMENT.addEventListener('click', this.toggleSubMenu.bind(this));

			MENU_ITEM.appendChild(DROPDOWN_ELEMENT);
		}
    }
    
    // Wrap submenus in div
    wrapSubmenu() {

        const SUBMENUS = document.querySelectorAll('li ul.sub-menu');

		for (let i = 0; i < SUBMENUS.length; i++) {

            const SUBMENU = SUBMENUS[i];
            
			const WRAPPER = document.createElement('div');
            WRAPPER.className = 'submenu-wrapper';
            
            SUBMENU.parentNode.insertBefore(WRAPPER, SUBMENU);
            WRAPPER.appendChild(SUBMENU);
		}
    }

	// Close menu on submenu item click
	submenuOnClick() {

		const ALL_MENU_ITEMS = document.querySelectorAll('#menu-main-menu .current_page_item li');

		for (let i = 0; i < ALL_MENU_ITEMS.length; i++) {

			const MENU_ITEM = ALL_MENU_ITEMS[i];

			MENU_ITEM.addEventListener('click', () => {
				this.closeNavigation();
			});
		}
	}

	// Toggle submenu
	toggleSubMenu(e) {

		if (this.windowWidth <= 1160) {

			const THIS = e.target;
			const MENU_WRAP = THIS.parentNode;
			const SUBMENU_WRAP = MENU_WRAP.querySelector('.sub-menu');
			const SUBMENU_ITEMS = SUBMENU_WRAP.querySelectorAll('.menu-item');
	
			toggleClass(MENU_WRAP, 'menu-open');
	
			if (hasClass(MENU_WRAP, 'menu-open')) {
				this.subMenuAnimation(SUBMENU_ITEMS);
			} else {
				this.hideSubMenuItems(SUBMENU_ITEMS);
			}
		}
	}

	subMenuAnimation(targetElements) {
		anime({
			targets: targetElements,
			translateX: ['-50px', 0],
			opacity: [0, 1],
			elasticity: 100,
			duration: 700,
			delay: function(el, i) {
				return i * 75;
			}
		})
	}

	hideSubMenuItems(targetElements) {
		for (let i = 0; i < targetElements.length; i++) {
			const SUBMENU_ITEM = targetElements[i];
			SUBMENU_ITEM.admin.transform = 'translateX(-100%)';
		}
	}

	displaySubMenu() {
        if (this.ACTIVE_MENU_ITEM)
            addClass(this.ACTIVE_MENU_ITEM, 'show-submenu');
	}
}